/// <reference path="../../../app.definition.ts" />

interface IEcvErrorSource {
  getImageUrl(src: string, type: string): string;
  getUrlRefreshed(): boolean;
  setUrlRefreshed(flag: boolean): void;
}

class EcvErrorSource implements IEcvErrorSource {
  urlRefreshed: boolean = false;
  static $inject = ['APIService'];
  constructor(
    private APIService
  ) { }

  getUrlRefreshed(): boolean {
    return this.urlRefreshed;
  }

  setUrlRefreshed(flag: boolean) {
    this.urlRefreshed = flag;
  }

  getImageUrl(src: string, type: string): string {
    return this.APIService.getImageUrl(type, src);
  }
}

interface IErrorSourceScope extends ng.IScope {
  callback?: () => void; // It's a function and it's optional
}

function errorSource(): ng.IDirective {
  return {
    restrict: 'A',
    replace: false,
    controller: EcvErrorSource,
    scope: {
      'callback': '=?errSrcCallback'
    },
    link: (scope: IErrorSourceScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvErrorSource): void => {
      element.bind('error', function () {
        let type = "";
        if (!!attributes.type) {
          type = attributes.type;
        } else {
          type = "mugshots";
        }
        //If err-src image not available then call the callback function.
        if (attributes.errSrc == "NoErrSrc") {
          if (!!scope.callback) {
            scope.callback();
          }
        }
        else if (attributes.src != attributes.errSrc) {
          if (controller.getUrlRefreshed() == true) {
            attributes.$set('src', attributes.errSrc);
            if (!!scope.callback) {
              scope.callback();
            }
          }
          else {
            const url = attributes.src.split('?')[0].split('/').pop();
            attributes.$set('src', controller.getImageUrl(url, type));
            controller.setUrlRefreshed(true);
          }
        }
      });
    }
  };
}

angular.module('eCareVault.common.directives').directive('errSrc', errorSource);
